import { STATUS_COLORS, STATUS_LABELS } from "@/lib/api";

export default function StatusBadge({ status }) {
  const c = STATUS_COLORS[status] || STATUS_COLORS.in_pregatire;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${c.bg} ${c.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      {STATUS_LABELS[status] || status}
    </span>
  );
}
